import { FormControl } from "@angular/forms";
import { Validazioni } from "../interfaces/utilities";

export function validator(etichetta, valore, lista: Validazioni[]): boolean {
	let intersection: Validazioni = null;

	if (lista !== null) intersection = lista.find(x => x.etichetta == etichetta);
	else return false;
	if (intersection !== null) {
		if (intersection.validazione !== null)
			if (intersection.validazione.includes("reg:")) {
				let regex = new RegExp(
					intersection.validazione.substring(4, intersection.validazione.length)
				);
				return regex.test(valore);
			} else if (intersection.validazione.includes("dom:")) {
				let sub = intersection.validazione.substring(
					4,
					intersection.validazione.length
				);
				let dom = sub.split("|");
				let value = null;
				value = dom.find(x => x.toLowerCase() == valore.toLowerCase());
				return value !== null;
			} else return false;
	}
	return false;
}

export function getValidatorPattern(etichetta, lista: Validazioni[]): RegExp {
	let regex: RegExp = null;
	let intersection: Validazioni = null;

	if (lista !== null)
		intersection = lista.find(x => x.etichetta == etichetta);
	if (intersection !== null) {
		if (intersection.validazione !== null)
			if (intersection.validazione.includes("reg:")) {
				regex = new RegExp(
					intersection.validazione.substring(4, intersection.validazione.length)
				);
			}
	}
	return regex;
}

export function isRequired(etichetta, lista: Validazioni[]): boolean {
	let intersection: Validazioni = null;
	if (lista !== null) intersection = lista.find(x => x.etichetta == etichetta);
	else return false;

	if (intersection !== null) {
		return intersection.richiesto;
	}

	return false;
}

export function errorMessage(inputValue, fieldType, languageService): string {
	let error = languageService.getValue("validation_error");
	let field = languageService.getValue(fieldType);
	field = field !== null ? field.toLowerCase() : fieldType;
	if (error !== null) {
		error = error.replace("##value", inputValue);
		error = error.replace("##fieldType", field);
		return error;
	}
	return "This filed is not valid.";
}

export function editionNominationsPerCategory(number: number): boolean {
	return number > 0;
}
